







import Vue from "vue";
import { Prop, Component, Watch } from 'vue-property-decorator'
import { FramePuzzleModule } from '@/store/modules/framePuzzle';
import { AppModule } from '@/store/modules/app'

@Component({
  name: "frame-image-big"
})
export default class FrameImageBig extends Vue {
  @Prop() public inPreview!: boolean
  public assetId: number = 0

  get availableDesigns() {
    return FramePuzzleModule.availableDesigns
  }

  @Watch('availableDesigns')
  availableDesignsChanged() {
    this.setBoxSourceImageBig()
  }

  get designNr() {
    return FramePuzzleModule.boxDesign
  }

  @Watch('designNr')
  onDesignNrChanged() {
    this.setBoxSourceImageBig()
  }

  get isLandscapeFormat() {
    return FramePuzzleModule.isLandscapeFormat
  }

  get parts() {
    return FramePuzzleModule.parts
  }

  setBoxSourceImageBig() {
    for (let i = 0; i < this.availableDesigns.length; i++) {
      for (let j = 0; j < this.availableDesigns[i].length; j++) {
        if (this.availableDesigns[i][j].designNr === this.designNr) {
          let boxSourceImageBig = this.availableDesigns[i][j].boxSourceImageOverlayBig
          if (boxSourceImageBig) {
            this.assetId = boxSourceImageBig
            return
          }
        }
      }
    }
  }

  get link() {
    let url = '/cpapi/design/asset/'
    url += this.sessionId
    url += '/'
    url += this.assetId
    return url
  }

  get sessionId() {
    if (AppModule.session && AppModule.session.sessionId) {
      return AppModule.session.sessionId
    }
    return ""
  }

  mounted() {
    this.setBoxSourceImageBig()
  }
}
